import { extendTheme } from "@chakra-ui/react"
import Colors from "./theme/Colors"
import Fonts from "./theme/Fonts"
import FontWeight from "./theme/FontWeights"
import BorderRadii from "./theme/BorderRadii"
import GlobalStyle from "./theme/GlobalStyles"
import Components from "./theme/Components"
import FontSizes from "./theme/FontSizes"

const CustomTheme = extendTheme({
  colors: Colors,
  fonts: Fonts,
  fontWeight: FontWeight,
  fontSizes: FontSizes,
  borderRadius: BorderRadii,
  shadows: {
    floating: "0 0 10px 0 rgba(0, 0, 0, 0.5)",
    panel: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)",
  },
  sizes: {
    sidebar: "14em",
  },
  styles: GlobalStyle,
  components: Components,
})

export default CustomTheme
